'use client';

import { useEffect } from 'react';

function describe(n: any) {
  if (!n) return n;
  if (n.nodeType === 3) return { nodeType: 3, text: String(n.textContent).slice(0, 60) };
  if (n.nodeType !== 1) return { nodeType: n.nodeType };

  const el = n as HTMLElement;
  return {
    nodeType: 1,
    tag: el.tagName?.toLowerCase(),
    id: el.id || null,
    class: el.className || null,
    dataAttrs: el.dataset ? { ...el.dataset } : null,
    aria: {
      role: el.getAttribute?.('role'),
      label: el.getAttribute?.('aria-label'),
    },
  };
}

export default function DomRemoveChildTracer() {
  useEffect(() => {
    // Включай только когда надо: NEXT_PUBLIC_DOM_TRACE=1
    if (process.env.NEXT_PUBLIC_DOM_TRACE !== '1') return;

    const orig = Node.prototype.removeChild;

    // @ts-ignore
    Node.prototype.removeChild = function patchedRemoveChild(child: Node) {
      try {
        // @ts-ignore
        return orig.call(this, child);
      } catch (e: any) {
        if (e?.name === 'NotFoundError') {
          console.group('[DOM removeChild NotFoundError]');
          console.log('pathname:', window.location.pathname);
          console.log('parent:', describe(this));
          console.log('child:', describe(child));
          console.log('activeElement:', describe(document.activeElement));
          console.trace('removeChild trace');
          console.groupEnd();
        }
        throw e;
      }
    };

    return () => {
      Node.prototype.removeChild = orig;
    };
  }, []);

  return null;
}
